<!--
 KB-META
 Purpose: Help modal component
 Role: ui.template
 EntryPoints: click→hideDialog
 Inputs: style; header; modal; draggable; resizable
 Outputs: 
 Validation: 
 Dependencies: p-toast, p-dialog, ngx-extended-pdf-viewer, ng-template
 Contracts: 
 Auth&Privacy: auth:none; hipaa:none; pii:none
 Observability: 
 Router: shard=partner-portal-cura; H2=help-modal/help-modal.component; tags=ui,template,a11y
 Owner: ; LastReviewed: 2025-08-25
-->
<p-toast></p-toast>

<p-dialog 
  [(visible)]="isHelpDialogVisible" 
  [style]="{ width: '650px' }" 
  [header]="tab ? tab + ' Help' : 'Help'"
  [modal]="true" 
  [draggable]="false" 
  [resizable]="false"
  styleClass="help-dialog">
  
  <div class="card-body">
    <p-tabView *ngIf="isHelpDialogVisible" [(activeIndex)]="activeTabIndex">
      
      <!-- HOW Tab -->
      <p-tabPanel *ngIf="tipsBody || tipsImage" header="HOW">
        <div>
          <h3>{{ tab }}</h3>
        </div>
        <div class="pd-btm-60">
          <div class="content-section" [innerHTML]="getSafeHtml(tipsBody)">
          </div>
          <img *ngIf="isTipsImage" [src]="tipsImage" alt="How to" class="w-full" />
        </div>
      </p-tabPanel>
      
      <!-- INSPIRATION Tab -->
      <p-tabPanel *ngIf="inspirationBody || inspirationImage" header="INSPIRATION">
        <div>
          <h3>Inspiration</h3>
        </div>
        <div class="pd-btm-60">
          <div class="content-section" *ngIf="inspirationBody" [innerHTML]="getSafeHtml(inspirationBody)"></div>
          <div class="content-section" *ngIf="inspirationDefault" [innerHTML]="getSafeHtml(inspirationDefaultBody)"></div>
        </div>
        <img *ngIf="isInspirationImage" [src]="inspirationImage" alt="Inspiration" class="w-full" />
      </p-tabPanel>
      
      <!-- VIDEO Tab -->
      <p-tabPanel *ngIf="videoBody || isVideoImage" header="VIDEO">
        <div>
          <h3>Video</h3>
        </div>
        <div class="pd-btm-60" *ngIf="videoBody">
          <div class="content-section" [innerHTML]="getSafeHtml(videoBody)"></div>
        </div>
        <img *ngIf="isVideoImage" [src]="videoImage" alt="Video" class="w-full" />
        <img *ngIf="!isVideoImage && videoVideo" [src]="videoVideo" alt="Video" class="w-full" />
        <img *ngIf="!isVideoImage && !videoVideo" src="assets/images/onlinehelp.png" alt="Help" class="w-full" />
      </p-tabPanel>
      
      <!-- PDF Tab -->
      <p-tabPanel *ngIf="pdfUrl" header="PDF">
        <div class="pd-btm-60" style="height: 64vh;">
          <ngx-extended-pdf-viewer 
            [src]="pdfUrl" 
            [rotation]="0" 
            [zoom]="1" 
            style="width: 100%; height: 600px;">
          </ngx-extended-pdf-viewer>
        </div>
      </p-tabPanel>
      
    </p-tabView>
  </div>
  
  <ng-template pTemplate="footer">
    <button pButton label="Close" icon="pi pi-times" (click)="hideDialog()" class="p-button-text"></button>
  </ng-template>
</p-dialog> 